export default __webpack_public_path__ + "static/N0267-f5754fd47f709e20fd4d3164d76a93e4.png";